import store from '@/store';
import {requireModule} from '@/routes/guards';

const Diary = () => import(/* webpackChunkName: "diary-module" */ '@views/diary/Diary.vue');
const DiarySettings = () => import(/* webpackChunkName: "diary-module" */ '@views/diary/settings/views/DiarySettings.vue');
const DiaryStatuses = () => import(/* webpackChunkName: "diary-module" */ '@views/diary/settings/views/DiaryStatuses.vue');
const DiarySettingsIndex = () => import(/* webpackChunkName: "diary-module" */ '@views/diary/settings/index');
const Day = () => import(/* webpackChunkName: "diary-module" */ '@views/diary/views/Day.vue');
const Week = () => import(/* webpackChunkName: "diary-module" */ '@views/diary/views/Week.vue');

export default [
    {
        path: '/diary',
        components: {base: Diary},
        beforeEnter: requireModule('diaries', (to, from, next) => {
            if(store.getters.canAccessDiaryCourse || store.getters.canAccessDiaryManager) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        }),
        children: [
            {
                path: 'day',
                name: 'diary',
                components: {diary: Day}
            },
            {
                path: 'week',
                name: 'diary.weekly',
                components: {diary: Week}
            }
        ]
    },
    {
        path: '/diary/settings',
        components: {base: DiarySettingsIndex},
        beforeEnter: requireModule('diaries'),
        children: [
            {
                path: '',
                name: 'diary.settings.regular',
                components: {'diary-settings': DiarySettings},
                meta: { type: 1}
            },
            {
                path: '/diary/settings/special',
                name: 'diary.settings.special',
                components: {'diary-settings': DiarySettings},
                meta: { type: 2 }
            },
            {
                path: '/diary/settings/summer',
                name: 'diary.settings.summer',
                components: {'diary-settings': DiarySettings},
                meta: { type: 3 }
            },
            {
                path: '/diary/settings/types',
                name: 'diary.settings.types',
                components: {'diary-settings': DiaryStatuses}
            }
        ]
    }

];
